import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from './button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './card';
import { useLanguage } from '../../contexts/LanguageContext';

interface ErrorFallbackProps {
  error?: Error;
  onRetry: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, onRetry }) => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 w-12 h-12 bg-destructive/15 rounded-full flex items-center justify-center">
            <AlertTriangle className="h-6 w-6 text-destructive" />
          </div>
          <CardTitle className="text-xl">{t('error.boundary.title')}</CardTitle>
          <CardDescription>{t('error.boundary.description')}</CardDescription>
        </CardHeader>
        <CardContent className="text-center">
          {import.meta.env.DEV && error && (
            <div className="mb-4 p-3 bg-destructive/10 rounded-lg">
              <p className="text-sm text-destructive font-mono">{error.message}</p>
            </div>
          )}
          <Button onClick={onRetry} className="w-full">
            <RefreshCw className="mr-2 h-4 w-4" />
            {t('error.boundary.retry')}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default ErrorFallback;
